import React from 'react';
import { Switch } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormLabel from '@material-ui/core/FormLabel';
import text from './text';

const language = window.location.hash === '#en' ? 'eng' : 'hun';

export default ({filter, onChange}) => {
  return (
    <div className="filterByYear option">
      <FormLabel component="legend">{text[language].filtersGroupNames.years}</FormLabel>
      <FormControlLabel
        control={
          <Switch
            checked={filter["f2018"]}
            onClick={() => onChange("f2018")}
            color="primary"
          />
        }
        label={"2018"} 
      />

      <FormControlLabel
        control={
          <Switch
            checked={filter["f2017"]}
            onClick={() => onChange("f2017")}
            color="primary"
          />
        }
        label={"2017"}
      />

      <FormControlLabel
        control={
          <Switch
            checked={filter["f2016"]}
            onClick={() => onChange("f2016")}
            color="primary"
          />
        }
        label={"2016"}
      />

      <FormControlLabel
        control={
          <Switch
            checked={filter["f2015"]}
            onClick={() => onChange("f2015")}
            color="primary"
          />
        }
        label={"2015"}
      />
    </div>
  );
}